<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color} stroke-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 24 24">
    <path
      d="M4.13179 4H13.5576C14.8573 4 15.9115 5.19753 15.914 6.67054V8.05079L20.5798 5.87781C21.0238 5.6726 21.5298 5.91154 21.7133 6.41473C21.7555 6.5328 21.7778 6.66211 21.7778 6.78861V16.2086C21.7778 16.7511 21.3934 17.1953 20.9146 17.1981C20.798 17.1981 20.6839 17.1728 20.5773 17.1222L15.9165 14.9408V16.3295C15.9165 17.8025 14.8598 18.9972 13.56 19H4.13427C2.83451 19 1.77783 17.8025 1.77783 16.3295V6.67054C1.77783 5.19753 2.83203 4.00281 4.13179 4ZM20.8625 16.3407C20.927 16.3688 20.999 16.3351 21.0238 16.2648C21.0287 16.2479 21.0337 16.2311 21.0337 16.2114V6.78861C21.0337 6.7099 20.9766 6.64805 20.9097 6.64805C20.8948 6.64805 20.8774 6.65086 20.8625 6.6593L15.9165 8.97002V14.03L20.8625 16.3407ZM2.52197 16.3407C2.52197 17.3499 3.24379 18.1651 4.13427 18.1679H13.56C14.4505 18.1679 15.1699 17.3499 15.1723 16.3407V6.67054C15.1723 5.66136 14.4505 4.84614 13.56 4.84333H4.13427C3.24379 4.84333 2.52445 5.66136 2.52197 6.67054V16.3407Z"
      :class="colorClass"
      stroke-width="0.5"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
